const AppStoreDownloadUrl = "https://apps.apple.com/us/app/memesical/id6753958069"

export {
    AppStoreDownloadUrl
};